import { render, staticRenderFns } from "./wxstream.vue?vue&type=template&id=8302dd12&"
import script from "./wxstream.vue?vue&type=script&lang=js&"
export * from "./wxstream.vue?vue&type=script&lang=js&"
import style0 from "./wxstream.vue?vue&type=style&index=0&id=8302dd12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.6.14_webpack@5.81.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports